import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]

import rifflemanImage from '@/assets/imgs/riffleman.jpg';

export default /*@__PURE__*/_defineComponent({
  __name: 'PalaRiffleUniversity',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "fill-height d-flex align-center justify-center" }, {
    default: _withCtx(() => [
      _createElementVNode("img", {
        src: _unref(rifflemanImage),
        class: "riffleman-image",
        alt: "Riffleman Logo"
      }, null, 8, _hoisted_1)
    ]),
    _: 1
  }))
}
}

})